var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 26.8146C26.5947 25.9661 28.4053 25.9661 29.875 26.8146L42.4945 34.1005C43.9642 34.949 44.8695 36.5171 44.8695 38.2141V52.7859C44.8695 54.4829 43.9642 56.051 42.4945 56.8995L29.875 64.1854C28.4053 65.0339 26.5947 65.0339 25.125 64.1854L12.5055 56.8995C11.0358 56.051 10.1305 54.4829 10.1305 52.7859V38.2141C10.1305 36.5171 11.0358 34.949 12.5055 34.1005L25.125 26.8146Z",
    stroke: "url(#paint0_linear_2_56)",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 36L27.5 46.5M27.5 46.5L11 35.5M27.5 46.5V65",
    stroke: "url(#paint1_linear_2_56)",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4532 9.88755C61.4532 6.54066 58.736 3.82324 55.3891 3.82324H41.6539C38.307 3.82324 35.5896 6.54066 35.5896 9.88755V20.9237C35.5896 24.2706 38.307 26.988 41.6539 26.988H42.8888C43.2139 26.988 43.5217 27.1343 43.7267 27.3868C43.9314 27.639 44.0119 27.9704 43.9451 28.2884L43.9448 28.2905C43.7505 29.217 44.1364 30.1689 44.9211 30.6988C45.7055 31.2286 46.7327 31.231 47.5198 30.7048L52.7622 27.2004C52.9696 27.0617 53.2131 26.988 53.4622 26.988H55.3891C58.736 26.988 61.4532 24.2706 61.4532 20.9237V9.88755ZM47.9752 9.58055C46.4462 9.86736 45.2874 11.211 45.2874 12.8228C45.2874 13.7179 45.4371 14.5212 45.9024 15.1082C46.3754 15.7049 47.1818 16.1217 48.5863 16.1217C49.3033 16.1217 49.7939 16.2547 50.1153 16.525C50.5948 16.9282 50.6632 17.5946 50.6632 18.3282C50.6632 19.546 49.6746 20.5346 48.4568 20.5346C47.4726 20.5346 46.6381 19.8889 46.3539 18.9983C46.2624 18.7112 45.9549 18.5523 45.6675 18.6441C45.3805 18.7356 45.2216 19.0431 45.3133 19.3305C45.6906 20.5137 46.7183 21.4079 47.9752 21.592V22.0631C47.9752 22.3646 48.22 22.6095 48.5215 22.6095C48.823 22.6095 49.0676 22.3646 49.0676 22.0631V21.5705C50.5966 21.2837 51.7554 19.9403 51.7554 18.3282C51.7554 17.2381 51.531 16.288 50.8184 15.6889C50.3452 15.2909 49.6418 15.0293 48.5863 15.0293C47.6446 15.0293 47.0757 14.8298 46.7584 14.4297C46.4339 14.0202 46.3799 13.4473 46.3799 12.8228C46.3799 11.605 47.3685 10.6164 48.5863 10.6164C49.5705 10.6164 50.405 11.2621 50.6889 12.1527C50.7807 12.4398 51.0882 12.5987 51.3753 12.5069C51.6624 12.4154 51.8212 12.1079 51.7297 11.8208C51.3522 10.6374 50.3245 9.74309 49.0676 9.55905V9.08793C49.0676 8.78643 48.823 8.54156 48.5215 8.54156C48.22 8.54156 47.9752 8.78643 47.9752 9.08793V9.58055Z",
    fill: "url(#paint2_linear_2_56)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_56",
    x1: 8,
    y1: 28,
    x2: 46,
    y2: 69.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#B0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_56",
    x1: 12.5116,
    y1: 38.2442,
    x2: 38.2413,
    y2: 69.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#B0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_56",
    x1: 36.7926,
    y1: 6.36041,
    x2: 60.9745,
    y2: 31.4034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C95AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#B0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.b66c41b2acd7b733aa4dc26872f0a6c7.svg";
export { ForwardRef as ReactComponent };